/* eslint-disable no-param-reassign */
import { html } from 'lit';
import { view } from '../factory.js';
import {
  observableValue,
  WritableObservableValue,
} from '../shared-state/index.js';
import '../utils/experiments.js';
import { ParserFormatter } from '../formatters/core.js';
import { useSharedState } from '../hooks/index.js';

export const [TextField] = view('esui-demo-text-field', {
  Props: class {
    value: WritableObservableValue<any> = observableValue('');
    formatter: ParserFormatter<unknown> = ParserFormatter.default;
  },

  mapBuilder: TextFieldBuilder => <T>(
    value: WritableObservableValue<T>,
    formatter: ParserFormatter<T> = ParserFormatter.default
  ) => TextFieldBuilder().value(value).formatter(formatter),

  template({ value, formatter }) {
    const sharedState = useSharedState(value);

    function handleInput(e: { target: HTMLInputElement }) {
      if (e.target.checkValidity())
        sharedState.value = formatter.parse(e.target.value);
    }

    return html`
      <input
        .value="${formatter.format(sharedState.value)}"
        @input="${handleInput}"
        type="${formatter.type}"
      />
    `;
  },
});
